/**
 * Created by Анжелика on 25.09.2017.
 */
import * as actionTypes from "../constants/actionTypes";
import {playChannel} from "../actions/channels";

export function channelCardAdd(channel) {
    return {type: actionTypes.CHANNEL_CARDS_ADD, channel: channel};
}

export function playChannelCard(channel) {
    return dispatch => {
        dispatch(playChannel(channel, false));
    }
}

export function loadChannelCardsUserConfig() {
    return (dispatch, getState) => {
        const {users: {userData: {config}}} = getState();
        if (config && config.channelCards) {
            dispatch({type: actionTypes.LOAD_CHANNEL_CARDS_USER_CONFIG, items: config.channelCards});
        }
    }
}

export function clearChannelCards() {
    return ({type: actionTypes.CLEAR_CHANNEL_CARDS});
}



// WEBPACK FOOTER //
// ./src/actions/channelCards.js